import { shape, func } from 'prop-types';

export default shape({
    formatMessage: func,
});
